import * as accountinfo from '../../actionTypes/Accounts/AccountInfo'
// set the accountDetails redux initialState
const initialState = {
  accountDetails: {
    'uuId': '',
    'UserID': '',
    'firstName': '',
    'lastName': '',
    'roleName': '',
    'userEmail': '',
    'jobTitle': '',
    'officeNumber': '',
    'mobilePhone': '',
    'fax': '',
    'isActive': 0,
    'isVerified': 0,
    'ownerAccountId': 0,
    'companyId': 0,
    'resetPassword': false,
    'status': false,
    'BrandId': '',
    'IsCorporate': 0,
    'CompanyType': '',
    'ViewFranchise': 0,
    'AccountId': '',
    'IsOwner': 0,
    'AccountTOSAgree': 1,
    'store': {
      'stores': ''
    },
    'corporateShare': []
  }
}

// call accountsDetails redux action & change the accountsDetails  state
export default function accountsDetails (state = initialState, action) {
  switch (action.type) {
    case accountinfo.GET_ACCOUNT:
    case accountinfo.UPDATE_ACCOUNT:
      state.accountDetails = action.accountDetails
      return {
        ...state
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/store/accountinfo.js